"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFaIcon = getFaIcon;
exports.onPhoneChange = onPhoneChange;
exports.formFieldFactory = formFieldFactory;

var _proLightSvgIcons = require("@fortawesome/pro-light-svg-icons");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _components = require("@qsite/components");

var _formik = require("formik");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactI18next = require("react-i18next");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledDisabledPostcode = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tposition: relative;\n\n\tlabel {\n\t\tposition: absolute;\n\t\ttop: -22px;\n\t\tleft: 40px;\n\t\tfont-size: ", ";\n\t}\n\n\ta {\n\t\tmargin-left: auto;\n\t\tmargin-right: 10px;\n\t}\n\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-items: center;\n\tpadding-left: 10px;\n\tmargin-top: 25px;\n\twidth: inherit;\n\n\t@media (max-width: 41em) {\n\t\tmargin-left: 20px;\n\t}\n\n\t.icon-span {\n\t\tcolor: ", ";\n\t\tmargin-bottom: 5px;\n\t\twidth: 15px;\n\t}\n\n\t.postcode-value {\n\t\tmargin-left: 13px;\n\t\tborder: none;\n\t\theight: 20px;\n\t\tfont-size: ", ";\n\n\t\t@media (max-width: 41em) {\n\t\t\tfont-size: ", ";\n\t\t}\n\t}\n"])), function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.smallFontSize);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.gray3;
}, function (_ref3) {
  var theme = _ref3.theme;
  return "".concat(theme.baseFontSize);
}, function (_ref4) {
  var theme = _ref4.theme;
  return "".concat(theme.smallFontSize);
});

function getFaIcon(name) {
  var icons = {
    faComment: _proLightSvgIcons.faComment,
    faUserAlt: _proLightSvgIcons.faUserAlt,
    faEnvelope: _proLightSvgIcons.faEnvelope,
    faMobile: _proLightSvgIcons.faMobile,
    faIdBadge: _proLightSvgIcons.faIdBadge,
    faAddressBook: _proLightSvgIcons.faAddressBook,
    faMapMarkerAlt: _proLightSvgIcons.faMapMarkerAlt,
    faMap: _proLightSvgIcons.faMap
  };
  return icons[name];
}

function onPhoneChange(e, validatePhoneLength) {
  e.preventDefault();
  var value = e.target.value;
  var phone = value.replace(/\D/g, '');

  if (validatePhoneLength === false) {
    return phone;
  }

  if (phone.length > 6) {
    return "".concat(phone.slice(0, 3), "-").concat(phone.slice(3, 6), "-").concat(phone.slice(6, 10));
  } else if (phone.length > 3) {
    return "".concat(phone.slice(0, 3), "-").concat(phone.slice(3, 6));
  } else {
    return phone;
  }
}

;

function formFieldFactory(config) {
  var i18n = (0, _reactI18next.useTranslation)();
  var field = config.field,
      handleChange = config.handleChange,
      values = config.values,
      errors = config.errors,
      touched = config.touched,
      setFieldValue = config.setFieldValue;
  var changeFunc = field.name.includes('phone') ? function (e) {
    var _field$validate_phone;

    var val = onPhoneChange(e, (_field$validate_phone = field === null || field === void 0 ? void 0 : field.validate_phone_length) !== null && _field$validate_phone !== void 0 ? _field$validate_phone : true);
    setFieldValue(field.name, val);
  } : handleChange;
  var icon = getFaIcon(field.icon);

  var handlePostcodeChange = function handlePostcodeChange(e) {
    e.preventDefault();
    e.stopPropagation();
    handleChange();
  };

  switch (field.type) {
    case 'checkbox':
      var labelId = field.name + 'Label';
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, field.options ? /*#__PURE__*/_react["default"].createElement("div", {
        role: "group",
        className: "".concat(field.name, "Field"),
        key: field.name,
        "aria-labelledby": labelId
      }, /*#__PURE__*/_react["default"].createElement("span", {
        id: labelId
      }, i18n.t(field.placeholder)), field.options.map(function (option) {
        return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement(_formik.Field, {
          type: "checkbox",
          name: field.name,
          value: option
        }), option));
      })) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(field.name, "Field"),
        key: field.name
      }, /*#__PURE__*/_react["default"].createElement("input", {
        type: "hidden",
        name: field.name
      }), /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement(_formik.Field, {
        type: "checkbox",
        name: field.name
      }), field.placeholder))), /*#__PURE__*/_react["default"].createElement(_components.ErrorMessageCustomed, {
        id: "".concat(field.id, "-error"),
        "data-testid": "".concat(field.id, "-error"),
        name: field.name,
        message: field.name
      }));

    case 'radio':
      var labelId = field.name + 'Label';
      return /*#__PURE__*/_react["default"].createElement("div", {
        role: "group",
        className: "".concat(field.name, "Field"),
        key: field.name,
        "aria-labelledby": labelId
      }, /*#__PURE__*/_react["default"].createElement("span", {
        id: labelId
      }, i18n.t(field.placeholder)), field.options.map(function (option) {
        return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement(_formik.Field, {
          type: "radio",
          name: field.name,
          value: option,
          className: errors[field.name] && touched[field.name] ? 'invalid' : ''
        }), i18n.t(option)));
      }), /*#__PURE__*/_react["default"].createElement(_components.ErrorMessageCustomed, {
        id: "".concat(field.id, "-error"),
        "data-testid": "".concat(field.id, "-error"),
        name: field.name,
        message: field.name
      }));

    default:
    case 'text':
    case 'textarea':
    case 'email':
    case 'tel':
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: "".concat(field.name, "Field"),
        key: field.name
      }, /*#__PURE__*/_react["default"].createElement(_components.Input, {
        id: field.id,
        name: field.name,
        type: field.type,
        ref: field === null || field === void 0 ? void 0 : field.ref,
        icon: /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
          icon: icon
        }),
        dataTestId: field.dataTestId,
        placeholder: i18n.t("".concat(field.placeholder)),
        value: values[field.name],
        ariaInvalid: !!errors[field.name],
        ariaDescribedBy: "".concat(field.name, "-error ").concat(field.name, "-format"),
        ariaRequired: field.required,
        minLength: field === null || field === void 0 ? void 0 : field.minLength,
        maxLength: field === null || field === void 0 ? void 0 : field.maxLength,
        maxLengthLabel: field === null || field === void 0 ? void 0 : field.maxLengthLabel,
        disabled: field.disabled,
        onChange: changeFunc,
        autoComplete: field.autoComplete,
        className: errors[field.name] && touched[field.name] ? 'invalid' : ''
      }), /*#__PURE__*/_react["default"].createElement(_components.ErrorMessageCustomed, {
        id: "".concat(field.id, "-error"),
        "data-testid": "".concat(field.id, "-error"),
        name: field.name,
        message: field.name
      }));

    case 'select':
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: "".concat(field.name, "Field"),
        key: field.name
      }, /*#__PURE__*/_react["default"].createElement(_components.Select, {
        id: field.id,
        name: field.name,
        label: field.label,
        icon: /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
          icon: icon
        }),
        dataTestId: field.name,
        options: field.options,
        value: values[field.name],
        onChange: changeFunc,
        className: errors[field.name] && touched[field.name] ? 'invalid' : '',
        ariaInvalid: !!errors[field.name],
        ariaDescribedBy: "".concat(field.name, "-error"),
        ariaRequired: field.required,
        disabled: field.disabled
      }), /*#__PURE__*/_react["default"].createElement(_components.ErrorMessageCustomed, {
        id: "".concat(field.id, "-error"),
        "data-testid": "".concat(field.id, "-error"),
        name: field.name,
        message: field.name
      }));

    case 'autocomplete':
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: "".concat(field.name, "Field"),
        key: field.name
      }, /*#__PURE__*/_react["default"].createElement(_formik.Field, {
        id: field.id,
        name: field.name,
        type: "text",
        icon: /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
          icon: icon
        }),
        dataTestId: field.name,
        component: _components.AddressSearchInput,
        placeholder: field.placeholder,
        className: errors[field.name] && touched[field.name] ? 'invalid' : '',
        handleAutocompletePostcode: handleChange,
        ariaInvalid: !!errors[field.name],
        ariaDescribedBy: "".concat(field.name, "-error ").concat(field.name, "-format"),
        ariaRequired: field.required,
        disabled: field.disabled,
        autoComplete: field.autoComplete,
        loadingText: field.loadingText
      }), /*#__PURE__*/_react["default"].createElement(_components.ErrorMessageCustomed, {
        id: "".concat(field.id, "-error"),
        "data-testid": "".concat(field.id, "-error"),
        name: field.name,
        message: field.name
      }));

    case 'addressAutocomplete':
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: "".concat(field === null || field === void 0 ? void 0 : field.name, "Field"),
        key: field === null || field === void 0 ? void 0 : field.name
      }, /*#__PURE__*/_react["default"].createElement(_formik.Field, {
        id: field.id,
        name: field.name,
        type: "text",
        ariaRequired: field === null || field === void 0 ? void 0 : field.required,
        component: _components.AddressPlacesAutocomplete,
        placeholder: i18n(field === null || field === void 0 ? void 0 : field.placeholder),
        className: errors !== null && errors !== void 0 && errors[field === null || field === void 0 ? void 0 : field.name] && touched !== null && touched !== void 0 && touched[field === null || field === void 0 ? void 0 : field.name] ? 'invalid' : '',
        suggestionsHelpTempStrings: field === null || field === void 0 ? void 0 : field.suggestionsHelpTempStrings,
        loadingText: field === null || field === void 0 ? void 0 : field.loadingText
      }), /*#__PURE__*/_react["default"].createElement(_components.ErrorMessageCustomed, {
        id: "".concat(field.id, "-error"),
        "data-testid": "".concat(field.id, "-error"),
        name: field.name,
        message: field.name
      }));

    case 'disabledPostcode':
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: "".concat(field.name, "Field"),
        key: field.name
      }, /*#__PURE__*/_react["default"].createElement(StyledDisabledPostcode, null, /*#__PURE__*/_react["default"].createElement("span", {
        className: "icon-span"
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: icon
      })), /*#__PURE__*/_react["default"].createElement("label", null, field.placeholder), /*#__PURE__*/_react["default"].createElement("span", {
        className: "postcode-value"
      }, values[field.name]), /*#__PURE__*/_react["default"].createElement("a", {
        href: "#",
        onClick: handlePostcodeChange
      }, field.changePostcodeLabel)));

    case 'a':
      return /*#__PURE__*/_react["default"].createElement("a", {
        href: "javascript:void(0);",
        onClick: field.customHandleChange
      }, field.placeholder);

    case 'blank':
      return /*#__PURE__*/_react["default"].createElement("span", null);
  }
}